import React from 'react';
import type { ListProperty } from './types';

type Props = {
  property: ListProperty;
};

export const ListPropertyValue = ({ property }: Props) => {
  return <>{property.values?.filter(Boolean).join(', ')}</>;
};
